/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import api from '../../../services/API';
import historico from '../../../services/Historico';
import { Row, Col } from 'react-bootstrap';
import sortFunc from '../../../utils/ordernarColunaInt';
import moment from 'moment-timezone';
import sortFuncDate from '../../../utils/ordernarColunaDate';
import ModalEditar from './ModalEditar/index';
import RemoteTable from '../RemoteTable/index';
import { useSelector } from 'react-redux';

export default function Revendas() {
  const usuario = useSelector((state) => {
    return state.usuario;
  });
  const [redesSelect, setRedesSelect] = useState([]);
  const [redeSelecionada, setRedeSelecionada] = useState('');
  const [filtros, setFiltros] = useState(getInitialDatatableFiltro());
  const [history, setHistory] = useState('');

  function getInitialDatatableFiltro() {
    const params = {
      completo: 1,
      rede: redeSelecionada,
    };

    if (usuario.permissao !== 2) {
      params.ativo = 1;
    }
    return params;
  }
  const columns = [
    {
      dataField: 'codigo',
      text: 'Código',
      sort: true,
    },
    {
      dataField: 'redeNome',
      text: 'Rede',
      sort: true,
    },
    {
      dataField: 'nomeFantasia',
      text: 'Nome Fantasia',
      sort: true,
      formatter: (celula, valor) => {
        return (
          <button
            className="btn-limpo"
            onClick={(e) => {
              e.preventDefault();
              historico.push(`revenda/${valor.cnpj}`);
            }}
          >
            <b>{valor.nomeFantasia}</b>
          </button>
        );
      },
    },
    {
      dataField: 'razaoSocial',
      text: 'Razão Social',
      sort: true,
    },
    {
      dataField: 'cnpj',
      text: 'CNPJ',
      formatter: (celula, valor) => {
        let cnpj = valor.cnpj.replace(/[^\d]/g, '');
        return cnpj.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          '$1.$2.$3/$4-$5'
        );
      },
      sort: true,
    },
    {
      dataField: 'telefone',
      text: 'Contato',
      sort: true,
      formatter: (celula, valor) => {
        return `(${valor.telefone.substring(0, 2)}) ${valor.telefone.substring(
          2,
          6
        )}-${valor.telefone.substring(6)}`;
      },
    },
    {
      dataField: 'endCidade',
      text: 'Cidade',
      sort: true,
    },
    {
      dataField: 'criadoEm',
      text: 'Data de Cadastro',
      formatter: (celula, valor) => {
        return valor.criadoEm && valor.criadoEm !== 0
          ? moment(valor.criadoEm).format('DD/MM/YYYY HH:mm:ss')
          : '';
      },
      sort: true,
    },
    {
      dataField: 'numeroParceiros',
      text: 'Nº Vendedores Dentais',
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'totalVendas',
      text: 'Total Vendas',
      formatter: (celula, valor) => {
        return Number(valor.totalVendas)
          .toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          .toString()
          .replace(/\u00a0/g, ' ');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'totalCusto',
      text: 'Total Custo',
      formatter: (celula, valor) => {
        return Number(valor.totalCusto)
          .toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          .toString()
          .replace(/\u00a0/g, ' ');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'totalPontos',
      text: 'Pontuação Total',
      formatter: (celula, valor) => {
        return Number(valor.totalPontos).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'saldoPontos',
      text: 'Saldo de Pontos',
      formatter: (celula, valor) => {
        return Number(valor.saldoPontos).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'saldoPontosAF',
      text: 'Saldo de Pontos AF',
      formatter: (celula, valor) => {
        return Number(valor.saldoPontosAF).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'resultado',
      text: 'Resultado AF',
      formatter: (celula, valor) => {
        return Number(
          Number(valor.saldoPontos) + Number(valor.saldoPontosAF)
        ).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'ultimaPontuacao',
      text: 'Última Pontuação',
      formatter: (celula, valor) => {
        return valor.ultimaPontuacao && valor.ultimaPontuacao !== 0
          ? moment(valor.ultimaPontuacao).format('DD/MM/YYYY HH:mm:ss')
          : '-';
      },
      sort: true,
      sortFunc: sortFuncDate,
    },
    {
      isDummyField: true,
      dataField: 'ativo',
      text: 'Ativo',
      sort: true,
      hidden: [2].includes(usuario.permissao) ? false : true,
    },
    {
      dataField: 'editar',
      isDummyField: true,
      text: 'Editar',
      sort: false,
      hidden: [1, 2].includes(usuario.permissao) ? false : true,
    },
    {
      dataField: 'apagar',
      isDummyField: true,
      text: 'Apagar',
      sort: false,
      hidden: [2].includes(usuario.permissao) ? false : true,
    },
  ];

  useEffect(() => {
    buscarRedes();
  }, []);

  useEffect(() => {
    loadHistory();
    setFiltros({ ...filtros, rede: redeSelecionada });
  }, [redeSelecionada]);

  const buscarRedes = async () => {
    const resultado = await api.get('/api/redes?ativo=1');
    if (resultado) {
      setRedesSelect(resultado.data.redes);
    }
  };

  const loadHistory = async () => {
    const resultado = await api.get('/api/historico/ultima-data');

    if (resultado) setHistory(resultado.data.history);
  };

  return (
    <Container fluid>
      <h4 className="pt-3 pb-3 f-black">Dentais</h4>
      <hr className="hr-loja mt-0 mb-4" />
      <Row>
        <Col xs={12} sm={6} md={4} lg={3} className="d-flex flex-column">
          <label htmlFor="redeSelecionada">Selecione uma Rede</label>
          <select
            className="input-select mb-3"
            name="redeSelecionada"
            id="redeSelecionada"
            onChange={(e) => setRedeSelecionada(e.target.value)}
            defaultValue=""
            placeholder=""
          >
            <option value="">Todas</option>
            {redesSelect.map((rede) => (
              <option value={rede.nome} key={rede.nome}>
                {rede.nome}
              </option>
            ))}
          </select>
        </Col>
      </Row>
      {history && (
        <Row>
          <Col>
            <p>
              Última atualização do Histórico:{' '}
              <b>
                {new Date(history?.criadoEm).toLocaleString('pt-BR', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                })}
              </b>
            </p>
          </Col>
        </Row>
      )}

      <div>
        <RemoteTable
          keyField="id"
          url={`/api/revendas`}
          filtros={filtros}
          colunas={columns}
          ordenacaoInicial={{ campo: 'nomeFantasia', direcao: 'asc' }}
          fieldModalExlcluir="nomeFantasia"
          modalEdit={ModalEditar}
        />
      </div>
    </Container>
  );
}
